import {
  FiBriefcase,
  FiDollarSign,
  FiFileText,
  FiGrid,
  // FiPower,
  FiSettings,
  FiSliders,
  FiSmartphone,
  FiTool,
  FiTrello,
  FiUser,
  FiUsers,
  FiZap
} from 'react-icons/fi'

import { format as dateFormat, startOfMonth, endOfMonth } from 'date-fns'
import { IoCarOutline, IoWalletOutline } from 'react-icons/io5'
import clone from 'lodash.clonedeep'

const currentMonth = [
  dateFormat(startOfMonth(new Date()), 'yyyy-MM-dd'),
  dateFormat(endOfMonth(new Date()), 'yyyy-MM-dd')
]

export const menus = {
  wholesalers: [
    {
      title: 'Dashboard',
      url: '/wholesalers/dashboard',
      icon: FiGrid,
      permissions: ['wholesaler_dashboard:show']
    },
    {
      title: 'Vendas',
      icon: FiFileText,
      permissions: ['wholesaler_sales:list'],
      url: `/wholesalers/sales?start_date=${currentMonth[0]}&end_date=${currentMonth[1]}&status=APROVADA`
    },
    {
      title: 'Pagamentos',
      icon: FiDollarSign,
      permissions: ['wholesaler_payments:list'],
      url: `/wholesalers/payments?created_at=${currentMonth}`
    },
    {
      title: 'Clientes',
      url: '/wholesalers/customers',
      icon: FiBriefcase,
      permissions: ['wholesaler_customers:list']
    },
    {
      title: 'Contas Bancárias',
      url: '/wholesalers/bank-accounts',
      icon: IoWalletOutline,
      permissions: ['wholesaler_bank_accounts:list']
    },
    {
      title: 'Configurações',
      icon: FiSettings,
      items: [
        {
          title: 'Maquinetas',
          url: '/wholesalers/devices',
          icon: FiSmartphone,
          permissions: ['wholesaler_devices:list']
        },
        {
          title: 'Planos',
          url: '/wholesalers/plans',
          icon: FiFileText,
          permissions: ['wholesaler_plans:list']
        },
        {
          title: 'Usuários',
          url: '/users',
          icon: FiUsers,
          permissions: ['users-unit:list']
        },
        {
          title: 'Perfis de Acesso',
          url: '/roles',
          icon: FiUser,
          permissions: ['roles:list']
        }
      ]
    }
  ],

  dispatchers: [
    {
      title: 'Dashboard',
      url: '/dispatchers/dashboard',
      icon: FiGrid,
      permissions: ['dispatcher_dashboard:show']
    },
    {
      title: 'Orçamento Rapido',
      url: '/dispatchers/budgets',
      icon: FiZap,
      permissions: ['dispatcher_budgets:list']
    },
    {
      title: 'Vendas',
      info: 'Prestação de Serviços',
      url: '/dispatchers/sales',
      icon: FiFileText,
      permissions: ['dispatcher_sales:list']
    },
    {
      title: 'Clientes',
      url: '/dispatchers/customers',
      icon: FiUsers,
      permissions: ['dispatcher_customers:list']
    },
    {
      title: 'Veículos',
      url: '/dispatchers/vehicles',
      icon: IoCarOutline,
      permissions: ['dispatcher_vehicles:list']
    },
    {
      title: 'Configuração',
      icon: FiSliders,
      items: [
        {
          title: 'Etapas da Venda',
          url: '/dispatchers/sale/stages',
          icon: FiTrello,
          permissions: ['dispatcher_sale-stages:list']
        },
        {
          title: 'Tipos de Servíço',
          url: '/dispatchers/services/types',
          icon: FiTool,
          permissions: ['dispatcher_service-types:list']
        },
        {
          title: 'Usuários',
          url: '/users',
          icon: FiUser,
          permissions: ['users-unit:list']
        },
        {
          title: 'Perfis de Acesso',
          url: '/roles',
          icon: FiUser,
          permissions: ['roles:list']
        }
      ]
    }
  ],

  finances: [
    {
      title: 'Dashboard',
      url: '/finances/dashboard',
      icon: FiGrid
      // permissions: []
    },
    {
      title: 'Despesas',
      icon: FiZap,
      permissions: ['finance_entries:list'],
      url: `/finances/entries?due_date=${currentMonth}`
    },
    {
      title: 'Categorias',
      url: '/finances/categories',
      icon: FiTrello,
      permissions: ['finance_categories:list']
    },
    {
      title: 'Configuração',
      icon: FiSliders,
      items: [
        {
          title: 'Usuários',
          url: '/users',
          icon: FiUser,
          permissions: ['users-unit:list']
        },
        {
          title: 'Perfis de Acesso',
          url: '/roles',
          icon: FiUser,
          permissions: ['roles:list']
        }
      ]
    }
  ]
}

export const checkMenuPermission = (module) => {
  return menu => {
    if (menu.items) {
      // It woks, buts it's not correct to make side effects inside a filter funcions.
      menu.items = menu.items.filter(checkMenuPermission(module))
      if (menu.items.length === 0) {
        return false
      }
    }

    if (!menu.permissions) {
      return true
    } else {
      return menu.permissions.every((permission) => {
        return module?.permissions?.includes(permission)
      })
    }
  }
}

export const getHomePage = (module) => {
  try {
    const menu = clone(menus[module?.name] || [])
    const availableMenus = menu.filter(checkMenuPermission(module))
    const firstAvailablePage = availableMenus.find(Boolean)
    return firstAvailablePage?.url || '/403'
  } catch (error) {
    console.error(error)
    return '/403'
  }
}
